export default __webpack_public_path__ + "static/media/asktheexpertblue.ae4e35b9.svg";